import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const MasterCostCenterService = {
    getList: async (orgId) => {
        try {
            const url = `/master-cost-centers?organizationId=${orgId}`;
            const response = await apiService.get(url, {
                headers: {
                               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
                        },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
},
    getDetail: async (id) => {
        try{
        const response = await apiService.get(`/master-cost-centers/${id}`,{
            headers: {
                               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
                        },
        });
        return response.data;
        } catch (error) {
            throw error;
        }
    },

    create: async (data) => {
        const response = await apiService.post("/master-cost-centers", data,{
            headers: {
                               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
                        },
        });
        return response.data;
    },

    update: async (id, data) => {
        const response = await apiService.put(`/master-cost-centers/${id}`, data,{
            headers: {
                               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
                        },
        });
        return response.data;
    },

    delete: async (id) => {
        const response = await apiService.delete(`/master-cost-centers/${id}`,{
            headers: {
                               authorization: "Bearer " + _BaseAPIService.retrieveToken(),
                        },
        });
        return response.data;
    },
}

export default MasterCostCenterService